<template>
    <div class="user-control">
        <div v-if="!isShow">
            <div class="search-submit">
                <a href="javascript:" @click="bindNewAdd">新增</a>
            </div>
            <table>
                <tr>
                    <td>用户id</td>
                    <td>用户名</td>
                    <td>性别</td>
                    <td>邮箱</td>
                    <td>电话号码</td>
                    <td>创建时间</td>
                    <td>是否删除</td>
                    <td>用户所属</td>
                </tr>
                <tr v-for="(item,index) in list" :key="index">
                    <td>{{item.id}}</td>
                    <td>{{item.username}}</td>
                    <td>{{item.gender}}</td>
                    <td>{{item.email}}</td>
                    <td>{{item.phone}}</td>
                    <td>{{item.create_time}}</td>
                    <td>
                        <a id="edit" href="javascript:" @click="bindEdit($event,item.id)">编辑</a>
                        <a id="remove" href="javascript:" @click="bindRemove($event,item.id)">删除</a>
                    </td>
                    <td>{{item.user_belong}}</td>
                </tr>
            </table>
            <div class="list-hint" v-show="isShowTip" @click="isShowTip = false">
                <div class="list-hint-box" @click.stop>
                    <p class="p1">确认删除</p>
                    <p class="p2">
                        <a href="javascript:" @click="bindConfirm">确定</a>
                        <a href="javascript:" @click="isShowTip = false">取消</a>
                    </p>
                </div>
            </div>
        </div>  
        <div class="user-edit" v-if="isShow">
            <div class="inputText">
                <span>*</span>
                <p>用户名</p>
                <div class="input-box">
                    <input type="text" name="name" v-model="name" placeholder="请输入渠道组匹配标识">
                </div>
                <i></i>
            </div>
            <div class="inputText inputRadio">
                <span>*</span>
                <p>性别</p>
                <div class="input-box">
                    <label class="flex flex-mid" for="nan">
                        <div class="input-box-radio">
                            <input type="radio" name="sex" value="0" v-model="sex" id="nan">
                            <span></span>
                        </div>
                        <span>男</span>
                    </label>
                    <label class="flex flex-mid" for="nv">
                        <div class="input-box-radio">
                            <input type="radio" name="sex" value="1" v-model="sex" id="nv">
                            <span></span>
                        </div>
                        <span>女</span>
                    </label>
                </div>
                <i></i>
            </div>
            <div class="inputText">
                <span>*</span>
                <p>邮箱</p>
                <div class="input-box">
                    <input type="text" name="email" v-model="email" placeholder="请输入邮箱地址">
                </div>
                <i></i>
            </div>
            <div class="inputText">
                <span>*</span>
                <p>电话号码</p>
                <div class="input-box">
                    <input type="text" name="phone" v-model="phone" placeholder="请输入电话号码">
                </div>
                <i></i>
            </div>
            <div class="inputSelect">
                <span>*</span>
                <p>用户所属</p>
                <div class="input-box">
                    <i class="icon iconfont icon-zheng-triangle" :class="{'rotate-icon':isShowList}"></i>
                    <div class="copyModel" @click.stop="bindChange">{{listName}}</div>
                    <ul :class="{'show-select':isShowList}" @click.stop>
                        <li v-for="(val,key,index) in listView" :key="index" @click="bindSelect($event,{val:val,key:key})">{{val}}</li>
                    </ul>
                </div>
                <i></i>
            </div>
            <div class="btn-box">
                <input-submit @getSubmit="bindCreate" :txt="'提交'" :color="'#ffcc00'"></input-submit>
                <input-submit @getSubmit="bindReturn" :txt="'返回'" :color="'deepskyblue'"></input-submit>
            </div>
        </div>
    </div>
</template>

<script>
    import inputSubmit from "./from/inputSubmit"
    import {mapActions} from "vuex"
    export default {
        name:"user-control",
        data(){
            return {
                isShow:false,
                total:0,
                pageSize:0,
                list:[],
                editList:[],
                // 编辑所需数据
                id:0,
                name:"",
                sex:0,
                email:"",
                phone:"",
                // 是否显示下拉列表
                isShowList:false,
                listView:"",
                listName:"请选择用户所属",
                listIndex:0,
                // 确认遮罩成
                isShowTip:false

            }
        },
        mounted(){
            var _this = this;
            this.bindGetList()
            $("body").on("click",function () {  
                _this.isShowList = false;
            })
        },
        watch:{
            "isShow":function(val){
                if(val == true && !sessionStorage.getItem("userList")){
                    var _this = this;
                    $.ajax({
                        url:webUrl+"/user/getEditInfo",
                        headers: {
                            'Auth-Token' : localStorage.getItem("token")
                        },
                        type:"POST",
                        data:{
                            id:0
                        },
                        dataType:"JSON",
                        success(res){
                            _this.listView = res.data.user_belong;
                            sessionStorage.setItem("userList",JSON.stringify(res.data.user_belong))
                        }
                    })
                }else{
                    try {
                        this.listView = JSON.parse(sessionStorage.getItem("userList"))
                    } catch (error) {
                        
                    }
                }
            }
        },
        methods:{
            ...mapActions(["setHint"]),
            // 获取列表数据
            bindGetList(){
                var _this = this;
                $.ajax({
                    url:webUrl+"/user/getData",
                    headers: {
                        'Auth-Token' : localStorage.getItem("token")
                    },
                    type:"POST",
                    data:{
                        page:0,
                        username:"",
                        phone:""
                    },
                    dataType:"JSON",
                    success(res){
                        _this.total = res.data.total;
                        _this.pageSize = res.data.pageSize;
                        _this.list = res.data.list;
                    }
                })
            },
            // 新增用户
            bindNewAdd(){
                this.isShow = true;
                this.id = -1;
                this.name = "";
                this.sex = 0;
                this.email = "";
                this.phone = "";
                this.listName = "请选择用户所属";
                this.listIndex = -1;
                this.isShowList = false;
            },
            // 编辑已有用户信息
            bindEdit(event,id){
                this.isShow = true;
                this.id = id;
                var _this = this;
                $.ajax({
                    url:webUrl+"/user/getEditInfo",
                    headers: {
                        'Auth-Token' : localStorage.getItem("token")
                    },
                    type:"POST",
                    data:{
                        id:id
                    },
                    dataType:"JSON",
                    success(res){
                        var db = res.data.user[0];
                        _this.listView = res.data.user_belong;
                        _this.name = db.username;
                        _this.sex = db.gender == 1?0:1;
                        _this.email = db.email;
                        _this.phone = db.phone;
                        _this.listName = res.data.user_belong[db.user_belong];
                        _this.listIndex = db.user_belong;
                        sessionStorage.setItem("userList",JSON.stringify(res.data.user_belong))
                    }
                })
            },
            // 删除用户
            bindRemove(event,id){
                this.isShowTip = true;
                this.id = id;
            },
            // 保存用户信息
            bindCreate(){
                var _this = this;
                var data = {
                    id:this.id,
                    username:this.name,
                    gender:this.sex-0+1,
                    email:this.email,
                    phone:this.phone,
                    user_belong:this.listIndex
                }
                if(this.id == -1){
                    delete data.id
                }
                if(!this.name){
                    this.setHint({txt:"请输入用户名",className:"hint-error"})
                }else if(!this.email || !/.+\@.+\.(com|cn)$/.test(this.email)){
                    this.setHint({txt:"请正确填写email",className:"hint-error"})
                }else if(!this.phone || !/(^(1)[0-9]{10}$)|(^[0-9]{0,4}\-[0-9]{8}$)/.test(this.phone)){
                    this.setHint({txt:"请正确填写手机号码",className:"hint-error"})
                }else if(this.listIndex == -1){
                    this.setHint({txt:"请选择用户所属",className:"hint-error"})
                }else{
                    $.ajax({
                        url:webUrl+"/user/saveData",
                        headers: {
                            'Auth-Token' : localStorage.getItem("token")
                        },
                        type:"POST",
                        data:data,
                        dataType:"JSON",
                        success(res){
                            _this.setHint({txt:"保存成功",className:"hint-success"})
                            _this.id = -1;
                            _this.isShow = false;
                            _this.bindGetList()
                        }
                    })
                }
            },
            // 返回列表页
            bindReturn(){
                this.isShow = false;
            },
            // 显示/隐藏下拉选项
            bindChange(){
                this.isShowList = !this.isShowList;
            },
            // 选择下拉内容
            bindSelect(event,db){
                this.listName = db.val
                this.listIndex = db.key
                this.isShowList = false;
            },
            // 是否确认删除
            bindConfirm(){
                var _this = this;
                $.ajax({
                    url:webUrl+"/user/delete",
                    headers: {
                        'Auth-Token' : localStorage.getItem("token")
                    },
                    type:"POST",
                    data:{
                        id:_this.id
                    },
                    dataType:"JSON",
                    success(res){
                        _this.id = -1;
                        _this.isShowTip = false
                        _this.setHint({txt:"删除成功",className:"hint-success"})
                        _this.bindGetList()
                    }
                })
            }
        },
        components:{
            inputSubmit:inputSubmit
        }
    }
</script>

<style>
.search-submit {
    padding-left: 0;
    padding-bottom: 20px;
}
table {
    width: 100%;
    font-size: 16px;
    border-collapse: collapse;
}
table td {
    padding: 15px 6px;
}
table tr:nth-child(odd) {
    background-color: #f7f7f7;
}
table td a#edit{
    color: #00BFFF;
}
table td a#remove{
    color:red;
}
.inputRadio .input-box{
   width: 320px;
   text-align: left;
   
}
.inputRadio .input-box span {
    color: #333;
}
.inputRadio .input-box label{
    padding-right: 20px;
}
.inputRadio .input-box label *{
    vertical-align: middle;
}
.btn-box {
    display: flex;
    justify-content: space-between;
    width: 460px;
    text-align: left;
    padding-left: 140px;
}

</style>




// WEBPACK FOOTER //
// src/components/main/userControl.vue